<template>
  <transition name="slide-down">
    <div
      v-if="isNative && showBanner && !sidebarOpen"
      :class="['network-banner', isOnline ? 'banner-online' : 'banner-offline']"
    >
      <span v-if="!isOnline">
        ⚠️ Sin conexión — Las operaciones se guardarán y sincronizarán al
        reconectarte
        <span v-if="pendingCount > 0">({{ pendingCount }} pendientes)</span>
      </span>
      <span v-else-if="justReconnected">
        ✓ Conexión restaurada
        <span v-if="syncState.isSyncing"> — Sincronizando...</span>
        <span v-else-if="syncState.pendingCount === 0">
          — Todo sincronizado</span
        >
      </span>
    </div>
  </transition>
</template>

<script>
import { refreshPendingCount, syncState } from "@/stores/syncStore";
import { Capacitor } from "@capacitor/core";

export default {
  name: "NetworkStatusBanner",
  data() {
    return {
      justReconnected: false,
      showBanner: false,
      hideTimer: null,
      sidebarOpen: false,
    };
  },
  computed: {
    isNative() {
      return Capacitor.isNativePlatform();
    },
    isOnline() {
      return this.$networkState.isOnline;
    },
    syncState() {
      return syncState;
    },
    pendingCount() {
      return syncState.pendingCount;
    },
  },
  watch: {
    isOnline(newVal, oldVal) {
      if (!newVal) {
        // Acaba de perder conexión
        this.justReconnected = false;
        this.showBanner = true;
        clearTimeout(this.hideTimer);
      } else if (newVal && oldVal === false) {
        // Acaba de recuperar conexión
        this.justReconnected = true;
        this.showBanner = true;
        refreshPendingCount();
        // Ocultar el banner de "restaurado" después de 4 segundos
        this.hideTimer = setTimeout(() => {
          this.showBanner = false;
          this.justReconnected = false;
        }, 4000);
      }
    },
  },
  mounted() {
    refreshPendingCount();
    this._onToggleBarra = () => {
      this.sidebarOpen = !this.sidebarOpen;
    };
    this._onSidebarClosed = () => {
      this.sidebarOpen = false;
    };
    this.$root.$on("toggle-barra", this._onToggleBarra);
    this.$root.$on("sidebar-closed", this._onSidebarClosed);
  },
  beforeDestroy() {
    this.$root.$off("toggle-barra", this._onToggleBarra);
    this.$root.$off("sidebar-closed", this._onSidebarClosed);
  },
};
</script>

<style scoped>
.network-banner {
  position: fixed;
  /* Aparece justo debajo del TopBar (50px) respetando el safe-area-inset-top del notch */
  top: calc(
    50px + max(var(--cap-inset-top, 0px), env(safe-area-inset-top, 0px))
  );
  left: 0;
  right: 0;
  z-index: 9998; /* Por debajo del TopBar si tuviera z-index, encima del contenido */
  padding: 10px 16px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: white;
}

.banner-offline {
  background-color: #e53e3e;
}

.banner-online {
  background-color: #38a169;
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.slide-down-enter,
.slide-down-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
</style>
